import { createSelector } from 'reselect';
import { UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
export const getThemeSettings = state => state.resources.themeSettings.themeSettings;
export const getThemeSettingsFetchStatus = (state, moduleProps = {}) => {
  const {
    folderPath
  } = moduleProps;
  if (!folderPath) return UNINITIALIZED;
  const requestObj = state.resources.themeSettings.themeSettingRequestStatus;
  return requestObj[folderPath] || UNINITIALIZED;
};
export const getThemeSettingsValues = createSelector([getThemeSettings], themeSettings => {
  if (!themeSettings.themeSettings || !themeSettings.themeSettings.values) {
    return {};
  }
  return themeSettings.themeSettings.values;
});
export const getThemeFields = createSelector([getThemeSettings], themeSettings => {
  if (!themeSettings.theme || !themeSettings.theme.fields) return [];
  return themeSettings.theme.fields;
});